import { render, staticRenderFns } from "./attorney-sent-to-title-company.vue?vue&type=template&id=4241e921"
import script from "./attorney-sent-to-title-company.vue?vue&type=script&lang=js"
export * from "./attorney-sent-to-title-company.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports